import ApiUtils from '@/utils/ApiUtils'

export default function WidgetLogoFooter(props) {


  const startFromScratch = () => {
    ApiUtils.clearToken()
    setTimeout(() => {
      window.location.reload()
    }, 1000)
  }

  return <a onClick={e => startFromScratch()}>
            <img src={ props.config.footerLogo || '/logo-with-name.png'}></img>
        </a>

}